module.exports = __webpack_public_path__ + "img/symbol_8.9c107058.png";